import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from '../../../../../store/campanhaReducer';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { formatDate } from 'base/src/utils/stringUtil';
import { Tag } from 'base/src/components/Tag';
import * as S from '../styles';

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    produtos: state.CampanhaProdutosReducer.byUsuarioCampanha,
  }),
  {}
);

export interface TabHistoricoProps extends PropsFromRedux<typeof connector> { }

function TabHistorico({ produtos }: TabHistoricoProps) {
  if (!produtos || produtos.length === 0) {
    return (
      <div style={{ padding: '20px 0' }}>
        <S.Text>Nenhum histórico de produtos disponível</S.Text>
      </div>
    );
  }

  return (
    <S.ExtratoContainer>
      <S.ExtratoHeader>
        <S.ExtratoTitle>Histórico de Produtos</S.ExtratoTitle>
        <S.ExtratoDescription>
          Produtos vendidos pelo participante na campanha
        </S.ExtratoDescription>
      </S.ExtratoHeader>
      <S.HistoricoList>
        {produtos.map((produto) => (
          <S.HistoricoItem key={produto.ProdutoID}>
            <S.HistoricoItemContent>
              <S.HistoricoItemHeader>
                <S.HistoricoItemTitle>
                  {produto.ProdutoNome}
                </S.HistoricoItemTitle>
                <Tag variant='warning'>
                  {produto.Qtde} {produto.Qtde === 1 ? 'unidade' : 'unidades'}
                </Tag>
              </S.HistoricoItemHeader>

              <S.HistoricoItemDetails>
                <S.HistoricoDetailRow>
                  <S.HistoricoDetailLabel>
                    Pontuação Final:
                  </S.HistoricoDetailLabel>
                  <S.HistoricoDetailValue isHighlight>
                    {Math.round(produto.PontuacaoFinal)} pts
                  </S.HistoricoDetailValue>
                </S.HistoricoDetailRow>

                <S.HistoricoDetailRow>
                  <S.HistoricoDetailLabel>
                    Valor Líquido:
                  </S.HistoricoDetailLabel>
                  <S.HistoricoDetailValue>
                    {formatToBRL(produto.ValorLiquido)}
                  </S.HistoricoDetailValue>
                </S.HistoricoDetailRow>

                {produto.DataUltimaVenda && (
                  <S.HistoricoDetailRow>
                    <S.HistoricoDetailLabel>
                      Última Venda:
                    </S.HistoricoDetailLabel>
                    <S.HistoricoDetailValue>
                      {formatDate(produto.DataUltimaVenda)}
                    </S.HistoricoDetailValue>
                  </S.HistoricoDetailRow>
                )}
              </S.HistoricoItemDetails>
            </S.HistoricoItemContent>
          </S.HistoricoItem>
        ))}
      </S.HistoricoList>
    </S.ExtratoContainer>
  );
}

export default connector(TabHistorico);
